import React from 'react';
import '../styles/components/Navbar.css';

interface NavbarProps {
  isVisible: boolean;
}

const Navbar: React.FC<NavbarProps> = ({ isVisible }) => {
  const navItems = [
    { name: 'Início', id: 'home' },
    { name: 'Quem Somos', id: 'about' },
    { name: 'Equipa', id: 'team' },
    { name: 'A Nossa Missão', id: 'mission' },
    { name: 'O Que Fazemos', id: 'work' },
    { name: 'Parcerias e Eventos', id: 'events' },
    { name: 'Contactos', id: 'contacts' },
  ];

const scrollToSection = (id: string) => {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({ 
      behavior: 'smooth', 
      block: 'center' // This centers the element vertically
    });
  }
};
  if (!isVisible) return null;

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {navItems.map((item) => (
          <button
            key={item.id}
            className="nav-button"
            onClick={() => scrollToSection(item.id)}
            aria-label={`Scroll to ${item.name} section`}
          >
            {item.name}
          </button>
        ))}
      </div>
    </nav>
  );
};

export default Navbar;